import { render } from "./ConfigureSettings.vue?vue&type=template&id=3fa1591a&scoped=true"
import script from "./ConfigureSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureSettings.vue?vue&type=script&lang=js"

import "./ConfigureSettings.vue?vue&type=style&index=0&id=3fa1591a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3fa1591a"

export default script